module.exports = __webpack_public_path__ + "img/03.52913e2f.png";